import React, { useState, useEffect } from 'react';
import Wrapper from './styles';
import axios from 'axios';
import { useCartContext } from '../../context/cart_context';
import { useUserContext } from '../../context/user_context';
import { useOrderContext } from '../../context/order_context';
import { formatPrice } from '../../utils/helpers';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { payment_url as url } from '../../utils/constants';

const CheckoutForm = () => {
  const { cart, total_amount, shipping_fee, clearCart } = useCartContext();
  const { shipping, placeOrder } = useOrderContext();
  const { currentUser } = useUserContext();
  const history = useHistory();

  const [orderId, setOrderId] = useState('');

  const createOrder = async () => {
    try {
      const { data } = await axios.post(url, {
        cart,
        shipping_fee,
        total_amount,
        shipping: {
          name: shipping.name,
          address: shipping.address,
        },
      });
      setOrderId(data.orderId);
    } catch (error) {
      toast.error('Error connecting to payment gateway');
    }
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    const res = await loadRazorpayScript();

    if (!res) {
      toast.error('Razorpay SDK failed to load. Are you online?');
      return;
    }

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: (shipping_fee + total_amount) * 100,
      currency: 'INR',
      name: 'Diy World',
      image: 'https://diyworld.vercel.app/logo.png',

      description: 'Paying for shopping',
      order_id: orderId,
      handler: async (response) => {
        // Payment Success
        await placeOrder();
        clearCart();
        history.push('/orders');
      },
      prefill: {
        name: shipping.name,
        email: currentUser.email,
        contact: '',
      },
      notes: {
        address: shipping.address,
      },
      theme: {
        color: '#F37254',
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  useEffect(() => {
    createOrder();
    // eslint-disable-next-line
  }, []);

  return (
    <Wrapper>
      <article>
        <h4>
          Hello,{' '}
          {currentUser &&
            (currentUser?.displayName
              ? currentUser.displayName
              : currentUser.email)}
        </h4>
        <p>Your total is {formatPrice(shipping_fee + total_amount)}</p>
      </article>
      <button onClick={handlePayment}>Pay Now</button>
    </Wrapper>
  );
};

export default CheckoutForm;
